import { CONTACT_EMAIL } from "@/lib/contact";
import { Outcome } from "./Outcome";

/*
 * Deliberately vague about which failure happened, and deliberately specific
 * about what to do next.
 *
 * This page is only reachable without JavaScript, where there is no way to
 * hand the draft back into the fields — so the one useful thing it can say is
 * the address that definitely works. Telling a visitor whether it was a
 * missing API key or a provider outage would not change what they do.
 */
export function ContactTrouble() {
  return (
    <Outcome chip="Not sent" chipTone="red" title="That did not go through.">
      <p>
        Nothing reached us, so please do not assume we have it. Email{" "}
        <a className="k-link" href={`mailto:${CONTACT_EMAIL}`}>
          {CONTACT_EMAIL}
        </a>{" "}
        and we will pick it up from there — it goes to the same place the form
        does.
      </p>
    </Outcome>
  );
}
